<template>
    <div id="app" :style="{height: `${windowHeight}px`}">
        <router-view/>
    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize';

    export default {
        name: 'App',
        data() {
            return {}
        },
        mixins: [windowResize],
        mounted() {
        }
    }
</script>

<style lang="scss">
    body {
        margin: 0;
    }
    .el-pagination {
    float: right !important;
}
.el-button--text{
    padding: 4px !important;
}
    .el-button + .el-button {
        margin-left: 0;
    }

    #app {
        width: 100%;
        height: 100%;
        min-width: 1200px;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        color: #333;
        overflow: hidden;
    }

    .filter-container {
        padding: 12px;
        border-bottom: 1px solid #e4e7ed;
    }

    .search-input--right {
        width: 240px !important;
        float: right;
    }

    a {
        text-decoration: none;
        color: #333;
    }

    .el-dialog {
        border-radius: 10px;
    }

    .el-dialog__header {
        border-radius: 10px 10px 0 0;
        padding: 0 25px;
        height: 40px;
        line-height: 42px;
        background-color: #F7F7F7;
        border: 1px solid #EFEFEF;
    }

    .el-dialog__title {
        color: #54A2ED;
    }

    html {
        overflow: hidden;
    }

    .pagination-container {
        margin-top: 10px;
    }

    .content {
        padding: 0 12px;
    }

    .full-content {
        padding: 12px;
    }

    .form--display {
        .el-form-item {
            margin-bottom: 12px;
        }
    }
    .edui-editor, .edui-editor .el-form-item__content {
        line-height: 1em !important;
    }
    .link-type{
  color: #409EFF;
   cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue